"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var api_request_1 = require("../api_request");
var user_region_url_1 = require("../shared/user_region_url");
var core_link_1 = require("@reverbdotcom/commons/dist/components/core_link");
var url_helpers_1 = require("../shared/url_helpers");
var CATEGORIES = [
    {
        url: '/news?category_name=News+and+Reviews',
        translation: 'newsAndReviews',
    },
    {
        url: '/news?category_name=Tips+and+How-To%27s',
        translation: 'tips',
    },
    {
        url: '/news?category_name=Interviews',
        translation: 'interviews',
    },
    {
        url: '/news?category_name=Gear+History',
        translation: 'gearHistory',
    },
    {
        url: '/news?category_name=Demos',
        translation: 'demos',
    },
    {
        url: '/videos',
        translation: 'videos',
    },
];
var NewsDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(NewsDropdown, _super);
    function NewsDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            articles: [],
        };
        return _this;
    }
    NewsDropdown.prototype.componentDidMount = function () {
        var _this = this;
        api_request_1.V3.get(url_helpers_1.default.articlesRecentlyFeaturedPath()).then(function (res) {
            var _a;
            _this.setState({ articles: (_a = res) === null || _a === void 0 ? void 0 : _a.articles });
        });
    };
    NewsDropdown.prototype.renderArticles = function () {
        return this.state.articles.map(function (article, index) {
            return (React.createElement("li", { key: "article-" + index },
                React.createElement(core_link_1.default, { className: "news-dropdown__article__link", to: article._links.web.href },
                    React.createElement("img", { className: "news-dropdown__article__image", src: article._links.mobile_small.href, alt: article.title }),
                    React.createElement("div", { className: "pl-1" }, article.title))));
        });
    };
    NewsDropdown.prototype.renderCategories = function () {
        return CATEGORIES.map(function (category) {
            return (React.createElement("li", { key: category.translation },
                React.createElement(core_link_1.default, { className: "news-dropdown__category__link", to: user_region_url_1.default(category.url) }, I18n.t("discovery.newsDropdown." + category.translation))));
        });
    };
    NewsDropdown.prototype.render = function () {
        return (React.createElement("div", { className: "d-flex" },
            React.createElement("div", { className: "news-dropdown__articles" },
                React.createElement("ul", null,
                    this.renderArticles(),
                    React.createElement("li", { className: "padding-1" },
                        React.createElement(core_link_1.default, { className: "button button--orange width-100 size-90", to: user_region_url_1.default('/news') }, I18n.t('discovery.newsDropdown.viewAll'))))),
            React.createElement("div", null,
                React.createElement("ul", null, this.renderCategories()))));
    };
    return NewsDropdown;
}(React.Component));
exports.default = NewsDropdown;
//# sourceMappingURL=news_dropdown.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/new_header/news_dropdown.js
// module id = rf4R
// module chunks = 20 21